import { fetchAdministrationMarketplaceOverview } from "../../../api/administrationMarketplace";
import { createResourceLoader } from "../../state/keyedResourceLoader";
import type {
  MarketplaceAdministrationSlice,
  MarketplaceOverviewSlice,
} from "./types";

const loader = createResourceLoader();

export const marketplaceOverviewInitialState = {
  overview: null,
  overviewQuery: {},
  overviewHydrated: false,
  overviewLoading: false,
  overviewError: "",
};

export const resetMarketplaceOverviewRequests = loader.clear;

export const createMarketplaceOverviewSlice:
  MarketplaceAdministrationSlice<MarketplaceOverviewSlice> = (set, get) => ({
    ...marketplaceOverviewInitialState,
    loadOverview: (force = false, query = get().overviewQuery) => {
      const changed = JSON.stringify(query) !== JSON.stringify(get().overviewQuery);
      if (changed) loader.clear();
      set({ overviewQuery: query });
      return loader.load({
        force,
        cached: !changed && get().overviewHydrated,
        request: () => fetchAdministrationMarketplaceOverview(query),
        onStart: () => set({ overviewLoading: true, overviewError: "" }),
        onSuccess: (overview) => set({ overview, overviewHydrated: true }),
        onError: (overviewError) => set({ overviewError }),
        onFinish: () => set({ overviewLoading: false }),
        errorMessage: "Unable to load Marketplace overview.",
      });
    },
  });
